<script>
import SetCounter from '@components/counters/set-counter.vue';
import SetRow from '@components/exercise/set-row.vue';
import SetRowWorkout from '@components/workout/set-row-completed.vue';
import { programCircuitModelMixin } from '@mixins/models/program-circuit-model-mixin.js';
import {
  workoutComputed,
  workoutMethods,
  adminPanelComputed,
  clientProgramComputed,
  clientProgramMethods,
} from '@state/helpers';
export default {
  components: {
    SetCounter,
    SetRow,
    SetRowWorkout,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      default: () => {},
    },
    exerciseIndex: {
      type: Number,
      required: true,
      default: null,
    },
    circuitIndex: {
      type: Number,
      required: true,
      default: null,
    },
    circuit: {
      type: Object,
      required: true,
      default: () => {},
    },
    hideDetails: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [programCircuitModelMixin],
  data() {
    return {
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
    };
  },
  computed: {
    ...workoutComputed,
    ...adminPanelComputed,
    ...clientProgramComputed,
    hasMuscleGroups() {
      return (
        this.exercise &&
        this.exercise.muscleGroups &&
        this.exercise.muscleGroups.length
      );
    },
    hasExerciseDifficulty() {
      return (
        this.exercise &&
        this.exercise.exerciseDifficulty &&
        this.exercise.exerciseDifficulty.exerciseDifficulty_id
      );
    },
    isLastExercise() {
      return (
        this.selectedWorkout &&
        this.selectedWorkout.circuits &&
        this.selectedWorkout.circuits.length &&
        this.selectedWorkout.circuits[this.circuitIndex].exercises &&
        this.selectedWorkout.circuits[this.circuitIndex].exercises.length &&
        this.exerciseIndex + 1 ===
          this.selectedWorkout.circuits[this.circuitIndex].exercises.length
      );
    },
    thumbnailPhoto() {
      return this.exercise &&
        this.exercise.mediaAssets &&
        this.exercise.mediaAssets.thumbnailPhoto &&
        this.exercise.mediaAssets.thumbnailPhoto.url
        ? this.exercise.mediaAssets.thumbnailPhoto.url
        : this.placeholder;
    },
    isStartedWorkout() {
      return (
        this.programDay &&
        this.programDay.workouts &&
        this.programDay.workouts.length > 0 &&
        this.programDay.workouts[0].clientInput &&
        this.programDay.workouts[0].clientInput.startedAt
      );
    },
  },
  mounted() {},
  methods: {
    ...clientProgramMethods,
    ...workoutMethods,
    onUpdateSets(type) {
      this.setUpdateProgramWorkoutExerciseSet({
        setDirections: this.getProgramCircuitExerciseSetModel(),
        circuitIndex: this.circuitIndex,
        exerciseIndex: this.exerciseIndex,
        type,
      });
    },
    onAdjustReps(exerciseSetRep) {
      this.setUpdateProgramWorkoutExerciseSetReps({
        ...this.getProgramCircuitExerciseSetModel(),
        circuitIndex: this.circuitIndex,
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetRep.index,
        count: exerciseSetRep.count,
      });
    },
    onAdjustTime(exerciseSetTime) {
      this.setUpdateProgramWorkoutExerciseSetTime({
        ...this.getProgramCircuitExerciseSetModel(),
        circuitIndex: this.circuitIndex,
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetTime.index,
        count: exerciseSetTime.count,
      });
    },
    onAdjustWeight(exerciseSetWeight) {
      this.setUpdateProgramWorkoutExerciseSetWeight({
        ...this.getProgramCircuitExerciseSetModel(),
        circuitIndex: this.circuitIndex,
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetWeight.index,
        count: exerciseSetWeight.count,
      });
    },
    onAdjustRest(exerciseSetRest) {
      this.setUpdateProgramWorkoutExerciseSetRest({
        ...this.getProgramCircuitExerciseSetModel(),
        circuitIndex: this.circuitIndex,
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetRest.index,
        count: exerciseSetRest.count,
      });
    },
    formattedTime(time) {
      return this.$_getFormattedSeconds(time);
    },
    onChangeCircuitIntro(circuitIndex, e) {
      this.setUpdateProgramWorkoutCircuitIntro({
        circuitIndex: this.circuitIndex,
        intro: e.target.value === '' ? null : e.target.value,
      });
    },
    onChangeCircuitOutro(circuitIndex, e) {
      this.setUpdateProgramWorkoutCircuitOutro({
        circuitIndex: this.circuitIndex,
        outro: e.target.value === '' ? null : e.target.value,
      });
    },
  },
};
</script>

<template>
  <div :class="['exercise-set-details', { hide: hideDetails }]">
    <div
      class="circuit-intro"
      v-if="!hideDetails && exerciseIndex === 0 && !isStartedWorkout"
    >
      <label>Circuit Intro</label>
      <BaseInputText
        v-if="!hideDetails"
        class="input-notes"
        name="notes"
        placeholder="Add an intro to the circuit for the client"
        @input="(e) => onChangeCircuitIntro(circuitIndex, e)"
        :value="circuit.trainerFeedback.intro.text"
      />
    </div>
    <div
      class="circuit-outro"
      v-if="!hideDetails && exerciseIndex === 0 && !isStartedWorkout"
    >
      <label>Circuit Outro</label>
      <BaseInputText
        v-if="!hideDetails"
        class="input-notes"
        name="notes"
        placeholder="Add outro to the circuit for the client"
        @input="(e) => onChangeCircuitOutro(circuitIndex, e)"
        :value="circuit.trainerFeedback.outro.text"
      />
    </div>
    <div class="row">
      <div
        :class="[
          'row exercise-header',
          { padding: isStartedWorkout && !hideDetails },
        ]"
      >
        <div class="col-4">
          <img class="exercise-photo" :src="thumbnailPhoto" />
        </div>
        <div class="col">
          <h6 class="exercise-categories">
            <template v-if="hasMuscleGroups">
              <span v-for="(group, i) in exercise.muscleGroups" :key="i">
                {{ group.label
                }}<span v-if="i + 1 < exercise.muscleGroups.length">,</span>
              </span>
            </template>
            <span v-if="hasExerciseDifficulty">
              / {{ exercise.exerciseDifficulty.label }}
            </span>
          </h6>
          <h3 class="exercise-title">{{ exercise.label }}</h3>
        </div>
      </div>
      <div class="row counters">
        <div class="col-2">
          <div class="exercise-set-details-header-set">
            <span class="set-details-title">Sets</span>
          </div>
          <div v-if="isStartedWorkout">
            <SetRowWorkout
              :set="{ reps: exercise.setDirections.length }"
              :setOnly="true"
            />
          </div>
          <div v-if="!isStartedWorkout" class="row set-row">
            <div class="col">
              <SetCounter
                :count="exercise.setDirections.length"
                @update-sets="onUpdateSets"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="exercise-set-details-header">
            <div class="row">
              <div class="col">
                <span class="set-details-title">Reps</span>
              </div>
              <div class="col">
                <span class="set-details-title">Time</span>
              </div>
              <div class="col">
                <span class="set-details-title">Weight</span>
              </div>
              <div class="col">
                <span class="set-details-title">Rest After</span>
              </div>
            </div>
          </div>
          <div v-if="!isStartedWorkout">
            <SetRow
              v-for="(set, i) in exercise.setDirections"
              :key="i"
              :setDirections="set"
              :exerciseSetIndex="i"
              @adjust-reps="onAdjustReps"
              @adjust-time="onAdjustTime"
              @adjust-weight="onAdjustWeight"
              @adjust-rest="onAdjustRest"
            />
          </div>
          <div v-if="isStartedWorkout">
            <SetRowWorkout
              v-for="(set, i) in exercise.setDirections"
              :setOnly="false"
              :key="i"
              :set="set"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// stylelint-disable selector-pseudo-element-no-unknown
@import '@design';
.circuit-intro {
  background-color: $color-light-gray-eleven;
  padding-bottom: 0.1rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 1.5rem;
}
.circuit-outro {
  background-color: $color-light-gray-eleven;
  margin-bottom: 3rem;
  padding-bottom: 0.1rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
::v-deep .input {
  background-color: white;
  outline: unset;
}
.counters {
  padding-top: 3rem;
  width: 100%;
  .set-row {
    padding: 1.6rem 0;
  }
}
.exercise-set-details {
  // padding-top: 2.5rem;
  &.hide {
    .counters {
      display: none;
    }

    padding-bottom: 3rem;
  }
  &:not(:first-child) {
    border-top: 6px solid $color-light-gray-ten;
  }
  .row {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .exercise-photo {
    width: 100%;
  }
  .exercise-header {
    padding-top: 2.5rem;
    width: 100%;
    &.padding {
      padding-top: 3rem;
    }
  }
  .exercise-categories {
    color: $color-medium-gray-alt;
    font-size: 1.2rem;
    font-weight: 800;
    letter-spacing: 0.1px;
    line-height: 2.2rem;
    text-transform: uppercase;
  }
  .exercise-title {
    font-size: 2.1rem;
    font-weight: 900;
    letter-spacing: -0.3px;
    line-height: 2.4rem;
    margin-bottom: 1.6rem;
  }
  .exercise-set-details-header {
    border-bottom: 2px solid $color-light-gray;
    padding: 0 0 2.15rem;
    text-align: center;
    .col {
      text-align: center;
    }
    .row {
      padding-left: unset;
      padding-right: unset;
    }
  }
  .exercise-set-details-header-set {
    border-bottom: 2px solid $color-light-gray;
    padding: 0 0 2.15rem;
    text-align: center;
    .col {
      text-align: center;
    }
    .row {
      padding-left: unset;
      padding-right: unset;
    }
  }
  .set-details-title {
    color: $color-text;
    font-size: 1.2rem;
    font-weight: bold;
    letter-spacing: 1.34675px;
    line-height: 1.6rem;
    text-transform: uppercase;
    white-space: nowrap;
  }
  ::v-deep {
    .set-counter .set-num,
    .rep-counter.minimal .rep-num,
    .time-counter .time-num,
    .weight-counter .weight-num,
    .rest-counter .rest-num {
      font-size: 2rem;
    }
  }
  ::v-deep .set-counter {
    .set-controls {
      padding: 0;
      .set-icon-wrapper {
        height: 2.4rem;
        width: 2.4rem;
      }
      .set-num {
        margin-left: 2px;
        margin-right: 2px;
        @include calc-font-size(1.5);
      }
    }
  }
  ::v-deep .rep-counter {
    .rep-controls {
      .rep-icon-wrapper {
        height: 2.4rem;
        width: 2.4rem;
      }
      .rep-num {
        @include calc-font-size(1.5);

        margin-left: 2px;
        margin-right: 2px;
      }
    }
  }
  ::v-deep .time-counter {
    .time-controls {
      .time-icon-wrapper {
        height: 2.4rem;
        width: 2.4rem;
      }
      .time-num {
        @include calc-font-size(1.5);

        margin-left: 2px;
        margin-right: 2px;
      }
    }
  }
  ::v-deep .weight-counter {
    .weight-controls {
      .weight-icon-wrapper {
        height: 2.4rem;
        width: 2.4rem;
      }
      .weight-num {
        @include calc-font-size(1.5);
      }
    }
  }
  ::v-deep .rest-counter {
    .rest-controls {
      .rest-icon-wrapper {
        height: 2.4rem;
        width: 2.4rem;
      }
      .rest-num {
        @include calc-font-size(1.5);

        margin-left: 10%;
        margin-right: 10%;
      }
    }
  }
  .exercise-set-detail-counters {
    ::v-deep .row {
      flex-wrap: nowrap !important;
    }
    ::v-deep .col {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
  .btn-add-more {
    padding: 0.8rem 2rem;
    &:focus,
    &:active {
      padding: 0.8rem 2rem !important;
    }
    .icon-curl {
      width: 1.4rem;
    }
  }
}
</style>
